export const getFirstAndLastName = (name: string | undefined): string => {
  if (!name) return '';

  const firstAndLastName = name.split(' ').slice(0, 2).join(' ');
  return firstAndLastName;
};
